import React, { useState } from 'react';
import { Button, Card, Typography, Alert } from 'antd';
import { initFirebaseData } from '../utils/initFirebaseData';

const { Title } = Typography;

const DataInitializer = () => {
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const handleInitialize = async () => {
    try {
      setLoading(true);
      await initFirebaseData();
      setInitialized(true);
    } catch (error) {
      console.error('Error initializing data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card style={{ margin: '20px' }}>
      <Title level={3}>Инициализация данных Firebase</Title>
      
      {!initialized ? (
        <div>
          <Alert
            message="Внимание"
            description="Нажмите кнопку ниже для инициализации начальных данных в Firebase. Это добавит примеры игр, статей, документов и пользователей."
            type="info"
            showIcon
            style={{ marginBottom: '20px' }}
          />
          
          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={handleInitialize}
          >
            {loading ? 'Инициализация...' : 'Инициализировать данные'}
          </Button>
        </div>
      ) : (
        <Alert
          message="Данные успешно инициализированы!"
          description="Все начальные данные были добавлены в Firebase. Теперь вы можете управлять контентом через соответствующие разделы."
          type="success"
          showIcon
        />
      )}
    </Card>
  );
};

export default DataInitializer;
